import { render, staticRenderFns } from "./BasePerPageInput.vue?vue&type=template&id=40a345c8&"
import script from "./BasePerPageInput.vue?vue&type=script&lang=js&"
export * from "./BasePerPageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports